export const SKIP_REQUESTED_SYSTEMS_INTERCEPTOR_HEADER = 'x-skip-requested-systems';
export const REQUESTED_SYSTEMS_HEADER = 'x-requested-systems';
export const SKIP_BE4FE_HEADER = 'x-skip-be4fe';
